import React from "react";
import {ReactComponent as ArrayDownIcon} from '../../../../../../../../assets/main/groups/main-table/arrow-down-two.svg';
import {ReactComponent as ArrayUpIcon} from '../../../../../../../../assets/main/groups/main-table/arrow-up.svg';


interface ProfileNameProps {
    firstName: string | null;
    open: boolean;
}

export const ProfileName: React.FC<ProfileNameProps> = ({ firstName, open }) => {
    return (
        <span className="profile-name">
            {firstName}
            {open ? <ArrayUpIcon /> : <ArrayDownIcon />}
        </span>
    );
};